// Section Imports
import images from "../../assets/images/assets";
import ContactSection from "./ContactSection";

const ContactPage = () => {
  return (
    <div className="bg-transparent w-full p-4 pb-24 relative">
      <div className="bg-transparent">
        <ContactSection />
      </div>

      {/* Decorative Blur */}
      <img
        src={images.blur_2}
        alt="blur"
        className="absolute bottom-50 lg:-bottom-50 lg:-right-160 -right-70 md:-right-100 md:mirror-x"
      />
    </div>
  );
};

export default ContactPage;
